import { ComponentType } from 'react';
import { Extension } from '@ametista-ai/editor/extensions/base/Extension';
import { NodeViewComponentProps } from '@handlewithcare/react-prosemirror';
import { MarkSpec, NodeSpec } from 'prosemirror-model';
import { UserMention } from './components/Mention/UserMention';

export const EXTENSIONS_TO_NODE_VIEW: Record<string, ComponentType<NodeViewComponentProps>> = {
  mention: UserMention,
};

export function getNodeViewsFromExtensions(
  extensions: Extension<void | NodeSpec | MarkSpec>[]
): Record<string, ComponentType<NodeViewComponentProps>> {
  return extensions.reduce(
    (acc, extension) => {
      const nodeView = EXTENSIONS_TO_NODE_VIEW[extension.name];
      if (nodeView) {
        acc[extension.name] = nodeView;
      }
      return acc;
    },
    {} as Record<string, ComponentType<NodeViewComponentProps>>
  );
}
